// extracted by mini-css-extract-plugin
export var Projects = "style-module--Projects--2GtfJ";
export var MoreProjects = "style-module--MoreProjects--6Iz1E";